module.exports = __webpack_public_path__ + "static/content-01-9c411c45adc841edaffb7c31c0ba2490.jpg";